import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7","key":"svg-0"}],["path",{"d":"M11 4h2","key":"svg-1"}],["path",{"d":"M12 17v.01","key":"svg-2"}],["path",{"d":"M19 16v3","key":"svg-3"}],["path",{"d":"M19 22v.01","key":"svg-4"}]]

const IconDeviceMobileExclamation = createReactComponent('outline', 'device-mobile-exclamation', 'DeviceMobileExclamation', __iconNode);

export default IconDeviceMobileExclamation;